function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#9192A1",
  fillRule: "nonzero"
}), React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 1.525,
  d: "M3 10q1-3 3-3c2 0 2 3 4 3q2 0 3-3"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/pending.bcabe502.svg";
export { SvgComponent as ReactComponent };